// constants.js
export const ITEMS_PER_PAGE = 20;
export const MAX_SM_INPUT = 50;
export const MAX_MD_INPUT = 500;
export const MAX_LG_INPUT = 1500;
export const MAX_AUTHOR_INPUT = 18;
